import React from 'react';
import Header from './Header';
import Footer from './Footer';
import StickyButtons from '../common/StickyButtons';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFFEE]">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <StickyButtons />
    </div>
  );
};

export default Layout;
